import { render, staticRenderFns } from "./OrderPerson.vue?vue&type=template&id=2c1bc65c&scoped=true"
import script from "./OrderPerson.vue?vue&type=script&lang=js"
export * from "./OrderPerson.vue?vue&type=script&lang=js"
import style0 from "./OrderPerson.vue?vue&type=style&index=0&id=2c1bc65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1bc65c",
  null
  
)

export default component.exports